import {
  SupportTicketFilterNames,
  supportTicketFilterData,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import SearchIcon from "@redotech/redo-icons/search-md.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { SUPPORT_TICKET_SEARCH_FIELD_OPTIONS } from "./search-field-options";

export const SearchContainsAdvancedFilter: ArrayStringTableFilter<string> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: SearchIcon,
  operators: [
    ArrayStringFilterOperator.CONTAINS,
    ArrayStringFilterOperator.NOT_CONTAINS,
    ArrayStringFilterOperator.MATCHES_EXACTLY,
  ],
  data: supportTicketFilterData[SupportTicketFilterNames.SEARCH_CONTAINS],
  itemLabel: "keyword",
  itemLabelPlural: "keywords",
  displayName: "Search contains",
  multiValueInput: true,
  getValueSummary: (values) =>
    values.length === 1 ? (values[0] ?? "") : `${values.length} keywords`,
  propertyNameMultiselect: {
    options: SUPPORT_TICKET_SEARCH_FIELD_OPTIONS,
    placeholder: "Search within...",
  },
};
